import { Footer } from "src/components/Footer"
import { Header } from "src/components/Header"
import { Empowering } from "./sections/empowering"
import { IBANFaq } from "./sections/FAQ"
import { Hero } from "./sections/hero"
import { HeroPhone } from "./sections/hero-phone"
import { IBANHub } from "./sections/hub"
import { IBANJoin } from "./sections/join"
import { Possibilities } from "./sections/possibilities"
import { IBANSetup } from "./sections/Setup"

const IBANPage = () => {
  return (
    <div className="iban-page">
      <Header isDark={false} />
      <section>
        <Hero />
        <HeroPhone />
        <Empowering />
        <IBANHub />
        <Possibilities />
        <IBANSetup />
        <IBANFaq />
        <IBANJoin />
      </section>
      <Footer isDark />
    </div>
  )
}

export default IBANPage
